import React from "react";
import ProfileDetailRow, { ProfileRowPlacementType } from "../profile/ProfileDetailRow";
import { UserSummary, FamilySummary } from "../../gql/types";

type ParticipantSummary = UserSummary | FamilySummary;

type ParticipantSummaryRowProps = {
    participant: ParticipantSummary;
    placement?: ProfileRowPlacementType;
    isReadOnly?: boolean;
    className?: string;
    truncationLength?: number;
    textSize?: 'small' | 'regular';
};

const ParticipantSummaryRow: React.FC<ParticipantSummaryRowProps> = ({
    participant,
    placement = ProfileRowPlacementType.STANDALONE,
    isReadOnly,
    className,
    truncationLength,
    textSize,
}) => {
    if ("email" in participant) {
        // UserSummary
        return (
            <ProfileDetailRow
                name={`${participant.firstName || ""} ${participant.lastName || ""}`.trim()}
                profilePictureUrl={participant.profilePictureUrl !== null ? participant.profilePictureUrl : undefined}
                altText={participant.email}
                placement={placement}
                isReadOnly={isReadOnly}
                className={className}
                truncationLength={truncationLength}
                textSize={textSize}
            />
        );
    } else {
        // FamilySummary
        const profilePictureUrl = participant.parents?.[0]?.profilePictureUrl;
        const familyName = participant.name || "Family";

        return (
            <ProfileDetailRow
                name={familyName}
                profilePictureUrl={profilePictureUrl !== null ? profilePictureUrl : undefined}
                altText={familyName}
                placement={placement}
                isReadOnly={isReadOnly}
                className={className}
                truncationLength={truncationLength}
                textSize={textSize}
            />
        );
    }
};

export default ParticipantSummaryRow;
